export default __webpack_public_path__ + "static/media/nashLogo.b3f1c424.svg";